module.exports = __webpack_public_path__ + "img/fruit-tangerines-350x184.9a7aa6ac.jpg";